import { CustomParams } from "./adcall/CustomParams.js";


export enum AdCOMVideoPlacement  {
    INSTREAM = 1,
    ACCOMPANYING_CONTENT = 2,
    INTERSTITIAL = 3,
    STANDALONE = 4
}

export type AdCallParams = {


    custom_params?: CustomParams,
    pre_serialized_custom_params?: string[]
    description_url?: string,
    pod?: number,
    other_params?: {[k: string]: string},
    placement?: AdCOMVideoPlacement
    
}